module.exports = __webpack_public_path__ + "static/smart_0-1739119afb628b6f53942c1b742ffd33.png";